import { render, staticRenderFns } from "./DataView.vue?vue&type=template&id=4f345312&"
import script from "./DataView.vue?vue&type=script&lang=js&"
export * from "./DataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f345312')) {
      api.createRecord('4f345312', component.options)
    } else {
      api.reload('4f345312', component.options)
    }
    module.hot.accept("./DataView.vue?vue&type=template&id=4f345312&", function () {
      api.rerender('4f345312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Pages/DataView.vue"
export default component.exports